export const COMPANIES_LIST_HEADER_TITLE = "Clientes";
export const PROJECTS_LIST_HEADER_TITLE = "Clientes y Proyectos";
